import React from "react";

const EOI = () => {
  return (
    <>
      <h4 style={{ textAlign: "center" }}>University of Nepal</h4>
      <h3 style={{ textAlign: "center" }}>Call for Expression of Interest</h3>
      <p style={{ textAlign: "center" }}>
        Date of Publication: June 3, 2025 (2082/02/20)
      </p>

      <br />

      <p>
        The University of Nepal (UNepal) is a newly established, autonomous,
        multidisciplinary public university governed by an independent Board of
        Trustees. It is committed to providing high-quality education. UNepal is
        preparing to launch its first undergraduate program in August 2026.
        Rooted in the Liberal Arts and Sciences tradition, the program will
        consist of two years of foundation courses followed by two years of
        major-specific coursework. The program will offer a variety of majors
        under the following academic areas:
        <ul>
          <li>Philosophy, Politics, Economics, and Law</li>
          <li>Energy, Environment, and Climate Change</li>
          <li>
            Computer Science, Data Science, and Artificial Intelligence (AI)
          </li>
          <li>Physics, Chemistry, Biology, and Mathematics</li>
          <li>Economics, Finance, and Business Studies</li>
          <li>History, Culture, and Society</li>
          <li>Literature, Communication, and Media Studies</li>
          <li>Mind, Brain, and Behavior</li>
        </ul>
        UNepal is currently compiling a roster of academics and experts for
        short-term contractual engagements in academic, administrative, and
        managerial roles. The University also welcomes applications from
        prospective interns.
      </p>

      <p style={{ textDecoration: "underline", fontWeight: "bold" }}>
        Minimum Qualifications:
      </p>
      <ul>
        <li>
          <em>For academic roles:</em> Master’s degree with excellent academic
          performance and relevant teaching or research experience, or a PhD
          (postdoctoral experience preferred).
        </li>
        <li>
          <em>For administrative and managerial roles:</em> Bachelor’s degree
          with relevant experience.
        </li>
      </ul>

      <p>
        This call also invites non-resident Nepali and foreign academics and
        scholars for potential academic and research engagement, including as
        visiting faculty.
      </p>

      <p>
        Interested individuals are invited to submit an Expression of Interest
        (EOI), along with a detailed CV, by <strong>3 July 2025</strong> via
        email to{" "}
        <strong>
          <a href="mailto:hr@uon.edu.np">hr@uon.edu.np</a>
        </strong>
        . EOIs submitted after the deadline will be considered for inclusion in
        the roster for possible future opportunities.
      </p>

      <p>
        <strong>UNepal Contact Office:</strong>
        <p>
          Sanogaucharan, Gyaneshwor, Kathmandu
          <br />
          Tel: +977-1-5914588
          <br />
          Email: <a href="mailto:hr@uon.edu.np">hr@uon.edu.np</a>
        </p>
      </p>
    </>
  );
};

export default EOI;
